import { useEffect, useState } from "react"
import { Input, Button, Table, Space, Modal, Form, Popconfirm } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import _ from 'lodash'

const { Column } = Table

type fetchParams = {
    type_name: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let posting = false

    let fetchOtherParamsTmpl: fetchParams = {
        type_name: undefined
    }

    const [userData, setUserData] = useState<any>({ user_name: '', is_admin: '' })

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    const [id, setID] = useState<string>('')
    const [editVisible, setEditVisible] = useState<boolean>(false)
    const [form] = Form.useForm()

    useEffect(() => {
        let data: any = localStorage.getItem('userData')
        let d = JSON.parse(data)
        setUserData(d)

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleInputChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/mall_center/config/type/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            let p: any = { ...pagination }
            p.total = response.total

            setPagination(p)
            setData(response.records)

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const onFinish = (values: any) => {
        if (!posting) {
            posting = true

            let url = id ? '/mall_center/config/type/update' : '/mall_center/config/type/add'

            baseAxiosComplete.post(url, { type_id: id, ...values }).then((res: any) => {
                if (res.status === 0) {
                    posting = false

                    resetForm()
                    setEditVisible(false)
                }
            })
        }
    }

    const onConfirmDelete = (record: any) => {
        baseAxiosComplete.post('/mall_center/config/type/delete', {
            id: record.type_id

        }).then(res => {
            if (res.status === 0) {
                resetForm()
            }
        })
    }

    return (<div className="common-page">
        {/* 商城中心 -> 配置管理 -> 分类管理 */}
        <BreadCrumb position={['商城中心', '分类管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ width: '150px', marginRight: 5, marginBottom: 12 }} placeholder="商品分类名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'type_name') }} value={fetchOtherParams.type_name} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                {userData.is_admin == 1 && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => {
                    setID('');
                    setEditVisible(true)

                    form.setFieldsValue({
                        type_name: undefined,
                        order_num: undefined
                    })
                }} >添加</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="type_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="分类名称" dataIndex="type_name" key="type_name" />
                <Column title="商品数量" dataIndex="goods_num" key="goods_num" />
                <Column title="排序" dataIndex="order_num" key="order_num" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            {userData.is_admin == 1 && <Button type="primary" onClick={() => {
                                setID(record.type_id)
                                setEditVisible(true)

                                form.setFieldsValue({ type_name: record.type_name, order_num: record.order_num })
                            }}>编辑</Button>}

                            {userData.is_admin == 1 && <Popconfirm
                                title="确定删除?"
                                onConfirm={() => { onConfirmDelete(record) }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button>删除</Button>
                            </Popconfirm>}
                        </Space>
                    )}
                />
            </Table>
        </div>

        <Modal title={(id ? "编辑" : "添加") + "分类"} visible={editVisible} width={400} footer={false} onCancel={() => { setEditVisible(false) }}>
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish}>
                <Form.Item
                    label="分类名称"
                    name="type_name"
                    rules={[{ required: true, message: '输入分类名称，限4个字内' }, { max: 4, message: '分类名称不能超过4个字' }]}
                >
                    <Input type="text" />
                </Form.Item>

                <Form.Item
                    label="排序"
                    name="order_num"
                    rules={[
                        { required: true, message: '输入排序，限数字99内' }
                    ]}
                >
                    <Input type="number" min="1" max="99" />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}